// Phase 1A Phase 9C.2 — Process state icon definitions.
//
// 8 process glyphs. Distinguish quality from outcome — a losing
// result can still be process-correct. Chart lines = historical /
// process; never "guaranteed growth."

import type { IconDef } from "./icon-types.ts";

export const PROCESS_ICONS: Record<string, IconDef> = {
  "process.clv_positive": {
    key: "process.clv_positive",
    shapes: [
      { type: "polyline", points: "4,17 9,12 13,15 19,7" },
      { type: "polyline", points: "16,7 19,7 19,10" },
      { type: "polyline", points: "12,18 14,20 17,17" },
    ],
  },
  "process.clv_warning": {
    key: "process.clv_warning",
    shapes: [
      { type: "polyline", points: "4,17 9,12 13,15 19,7" },
      { type: "polyline", points: "16,7 19,7 19,10" },
      { type: "polygon", points: "13,16 17,16 15,20", filled: true },
    ],
  },
  "process.roi_sample_low": {
    key: "process.roi_sample_low",
    shapes: [
      { type: "polyline", points: "4,17 9,13 14,15 20,9" },
      { type: "line", x1: 6, y1: 19, x2: 18, y2: 7 },
    ],
  },
  "process.process_correct": {
    key: "process.process_correct",
    shapes: [
      { type: "polyline", points: "5,12 10,17 19,7" },
      { type: "circle", cx: 12, cy: 20, r: 1.2, filled: true },
    ],
  },
  "process.variance_loss": {
    key: "process.variance_loss",
    shapes: [
      { type: "polyline", points: "4,7 9,12 13,9 19,17" },
      { type: "polyline", points: "16,17 19,17 19,14" },
    ],
  },
  "process.process_warning": {
    key: "process.process_warning",
    shapes: [
      { type: "polyline", points: "4,17 9,12 13,15 19,7" },
      { type: "polygon", points: "11,15 15,15 13,19", filled: true },
    ],
  },
  "process.sample_valid": {
    key: "process.sample_valid",
    shapes: [
      { type: "path", d: "M7 5 H4 V19 H7" },
      { type: "path", d: "M17 5 H20 V19 H17" },
      { type: "rect", x: 9, y: 9, width: 6, height: 6, filled: true },
    ],
  },
  "process.sample_pending": {
    key: "process.sample_pending",
    shapes: [
      { type: "path", d: "M7 5 H4 V19 H7" },
      { type: "path", d: "M17 5 H20 V19 H17" },
    ],
  },
};
